import React from 'react';
import { connect } from 'react-redux';
import { Modal, Row, Col, Button, Tooltip, Icon } from 'antd';
import { serviceFields } from '../../const/simbix';
import Label from '../widgets/Label';
import { getValues } from '../../virtuoso/helper'
import { FieldViewProxy, FieldEditProxy } from '../adms/FieldProxies';
import { AdmsAsset, RdfTriplet } from '../../redux';
/** Отображение списка значений для карточки ADMS
 * Формируется таблица, содержащая столбец с названием поля и столбец со значением поля
 * Для отображения поля используются специальные компоненты. Виды компонент описаны в widgets.
 * Получает список 
 */
const sortedStartPart = ['http://www.w3.org/1999/02/22-rdf-syntax-ns#about', 'http://purl.org/dc/terms/title',
    'http://www.w3.org/1999/02/22-rdf-syntax-ns#type'];
const sortedFinishPart = ['http://www.w3.org/ns/dcat#accessURL', 'http://www.w3.org/ns/dcat#downloadURL',
    'http://purl.org/dc/terms/issued', 'http://www.w3.org/ns/dcat#byteSize'];
const exclude = ['NName', 'http://www.w3.org/1999/02/22-rdf-syntax-ns#type'];

//Фильтрует полученные свойства для отображения. Исключает служебные свойства, свойства с пустыми значениями
//predicates содержит все предикаты, имеющие значения
const filterForShow = (predicates, values) => {
    //if (predicates) return predicates;
    //Исключаем служебные элементы
    const first = predicates.filter(key => !serviceFields.includes(key)); 
    //Исключаем свойства, которые не должны показываться
    const properties = first.filter(key => !exclude.includes(key));
    //Формируем последовательность свойств для отображения
    //console.log(properties)
    return properties.sort ((a, b) => {
            //console.log("0", a, b);
            //Начало списка свойств
            let indexA = sortedStartPart.indexOf(a);
            let indexB = sortedStartPart.indexOf(b);
            //console.log("1", indexA, indexB);
            if (indexA>-1){
                if (indexB>-1) return indexA-indexB;
                return -1;
            };
            if (indexB>-1) return 1;
            //конец списка свойств
            indexA = sortedFinishPart.indexOf(a);
            indexB = sortedFinishPart.indexOf(b);
            //console.log("2", indexA, indexB);
            if (indexA>-1){
                if (indexB < 0) return 1;
                return indexA-indexB;
            };
            if (indexB>-1) return 1;
            return 0;
        });
}
//Отображение Меток на английском языке
const EnLabel = ({props}) =>{
    return <span>&nbsp;(<Label {...props} lang="en"/>)</span>
}
class AssetLabel extends React.Component {

    render() {
        const {lang} = this.props;
        //<div className="csi_field_div">!!!</div>
        //<div className="csi_field_div"><Label {...this.props} />{(lang!="en")&& <EnLabel props={this.props}/>}</div>
        return(
            <div className="csi_field_div">
                <Tooltip placement="left" title={this.props.iri}>
                    <Label {...this.props} />
                </Tooltip>
            </div>
        )
    }
}
class AssetLabel2 extends React.Component {
  render() {
    const {graph, iri, lang} = this.props;
    return(
      <div className="csi_field_div">{iri}</div>
    )
  }
}

const { confirm } = Modal;
/** Формирует выподающий список для операций */
const ButtonGroup = Button.Group;

/** Базовая компонента отображения свойств
 */
class WikiPageCard  extends React.Component {
    state = {
        selected: undefined,    //Свойство (predicat), которое редактируется, удаляется или для него осуществляется перерво
        operation: "view",      //Текущая операция. Может быть view, edit, delete
    }

    /** Обработчик действий над элементом в форме  */
    onAction (e, type, predicat) {
      e.preventDefault();
      //console.log("WikiPageCard.js onAction", e, type, predicat); console.log(this); 
      //Режим редактирования, удаления или перевода
      if ((type=="edit")||(type=="translate")){
        const value = getValues(predicat, this.props.lang, this.props.values);
        this.props.onSelected(type, this.props.iri, predicat, value);
        return;
      }
        if (type=="delete"){
            const { iri, onRemoveProperty } = this.props;
            const value = getValues(predicat, this.props.lang, this.props.values);
            confirm({
                title: 'Удалить выбранное свойство?',
                content: value,
                okText: 'Да',
                okType: 'danger',
                cancelText: 'Нет',
                onOk() {
                  console.log('OK', iri, predicat);
                  onRemoveProperty(iri, predicat);
                },
                onCancel() {
                    //this.setState({selected: predicat, operation: "view"})
                },
              });
            return;
        }
        if (type=="cancel"){
            this.setState({selected: predicat, operation: "view"})
            return;
        }
        if (type=="detail"){
            const {handlers} = this.props;
            if (handlers) handlers(e, predicat, type);
        }
              //Добавление новой ссылки в собъектное совойства
        if (type=="link"){
          this.setState({selectedIndividual: true, objectProperty: predicat});
      }
    }

  /** Вызывается после изменений в WikiPageCard при редактировании полей */
  onReloadProxy(subject, predicat){
    const {graph, onReload} = this.props;
    return onReload(subject, graph);
  };

  render(){
    //console.log(this); 
    const {operation, predicates, values, lang, factory, IRI} = this.props;
    const properties = filterForShow(predicates, values);
    //Временно отключим редактирование и удаление свой-ва в карточке
    const FieldProxy = (operation=="edit") ? FieldEditProxy: FieldViewProxy;
    const labelStyle = operation=="edit" ? { color: '#bfbfbf' } : undefined;
    return (
      <table className="big-rubber-blk" style={{width: "100%"}}>
        <tbody>
            <TopRow />
            <tr className="middle-row">
                <td className="middle-left-col"></td>
                <td className="blk-body">
                    <div className="assetCardTable_tr">
                        <Row style={labelStyle}> 
                            <Col span={10}><div className="assetCardTable_td" style={{width:"100%", float:"left"}}><div className="csi_field_div">URI</div></div></Col>
                            <Col span={14}><div className="assetCardTable_td"><div className="csi_value_div">{IRI}</div></div></Col>
                        </Row>
                    </div>
                </td>
                <td className="middle-right-col"></td>
            </tr>
            {properties.map((prop, i) => 
            <tr key={i} className="middle-row">
                <td className="middle-left-col"></td>
                <td className="blk-body">
                    <div className="assetCardTable_tr">
                        <Row key={i}> 
                            <Col span={10}>
                        <div className="assetCardTable_td" style={{width:"100%", float:"left"}}>
                            <AssetLabel iri={prop} />
                        </div>
                            </Col>
                            <Col span={14}>
                        <div className="assetCardTable_td">
                            <FieldProxy 
                                factory={factory} lang={lang} 
                                subject={IRI} predicat={prop} values={values}
                                onReload={(subject, predicat) => this.onReloadProxy(subject, predicat)}
                                {...this.state} />
                        </div>
                            </Col>
                        </Row>
                    </div>
                </td>
                <td className="middle-right-col"></td>
            </tr>
            )}
            <BottomRow />
        </tbody>
    </table>
        )
        }
}

const TopRow = () => 
    <tr className="top-row">
        <td className="top-left-corner"></td>
        <td className="top-middle"></td>
        <td className="top-right-corner"></td>
    </tr>
const BottomRow = () =>
    <tr className="bottom-row">
        <td className="bottom-left-corner"></td>
        <td className="bottom-middle"></td>
        <td className="bottom-right-corner"></td>
    </tr>

function mapStateToProps(state, props) {
    //Значения в store redux
    const {vasset, vset } = state;
    const {lang, graph, IRI} = props;
    const items = vasset.wikies.filter(item => item.object.value == IRI);
    const values = (items && Array.isArray(items) && items.length>0)? items[0].values: null;
    const predicates = (values && Array.isArray(values))?[...new Set(values.map(item => item.predicat.value))]:[];
    return {
      lang: (lang)?lang: vset.lang,
      graph: (graph)?graph: vset.graph,
      wikies: vasset.wikies,      //Текущие данные
      predicates,
      values,
    };
}
export default connect(
    mapStateToProps,
    dispatch => ({
        onReload(subject, graph){
            return RdfTriplet.loadSubject(subject, graph).then(response =>{
                //console.log("WikiPageCard.js onReload 2", subject, graph, response);
                const {bindings, head} = response;
                return dispatch(AdmsAsset.RELOAD_WIKI(subject, bindings));
            });
        },
        onSelected(type, subject, prdicat, object){
          return dispatch(RdfTriplet.SELECTED(type, subject, prdicat, object));
        },
        onRemoveProperty(subject, predicat){
          return dispatch(AdmsAsset.removeProperty(subject, predicat));
        },
      })
  )(WikiPageCard);